import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { MatButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { Facility } from '../../../facilities/facility'
import { FacilityContextService } from '../facility-context.service'

@Component({
  selector: 'app-facility-context-menu',
  templateUrl: './facility-context-menu.component.html',
  styleUrls: ['./facility-context-menu.component.scss'],
  imports: [MatButton, MatIcon, MatMenu, MatMenuItem, MatMenuTrigger],
})
export class FacilityContextMenuComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)
  private readonly facilityContextService = inject(FacilityContextService)
  protected readonly activeFacility = toSignal(this.facilityContextService.facility$)
  private readonly availableFacilities = toSignal(
    this.facilityContextService.availableFacilities$,
    { initialValue: [] }
  )

  /***************************************************************************
   *                                                                         *
   * Template API                                                            *
   *                                                                         *
   **************************************************************************/

  protected readonly availableFacilitiesSorted = computed(() =>
    [...this.availableFacilities()].sort((a, b) => a.id.localeCompare(b.id))
  )

  protected readonly setActiveFacility = (facility: Facility): void => {
    this.facilityContextService.setFacility(facility)
  }
}
